import Notification from './src/notification.js';
export default Notification;



// WEBPACK FOOTER //
// ./src/packages/notification/index.js